import { CarouselDisplayStyle } from '@honeycomb/data';
import { BackgroundImage, colorToCssValue, Container, FlexGrid, Styler, useCulture } from '@honeycomb/ui-core';
import React, { useMemo } from 'react';
import { GenericRootComponentContext } from './GenericRootComponent.context';
import { DEFAULT_COMPONENT_PADDING, getWidgetBackgroundProps, useResolveCMSColors, } from '../utils';
import { PersonalisedProductContextProvider } from '../PersonalisedProduct';
import { GenericSubComponent } from '../GenericSubComponent';
export function GenericRootComponent(props) {
    const { component, moreLinkText, zoneIds } = props;
    const { alias, carouselDisplayStyle, backgrounds, backgroundColor: backgroundColorCMS, textColor: textColorCMS, } = component;
    const { dir } = useCulture();
    const isRTL = dir === 'rtl';
    const backgroundProps = useMemo(() => {
        return backgrounds && backgrounds.length > 0
            ? getWidgetBackgroundProps(backgrounds)
            : null;
    }, [backgrounds]);
    const { backgroundColor, textColor, isBackgroundDark } = useResolveCMSColors({
        backgroundColorCMS: backgroundColorCMS || undefined,
        textColorCMS: textColorCMS || undefined,
    });
    const contextValues = useMemo(() => {
        return {
            backgroundColor,
            textColor,
            isBackgroundDark,
            carouselDisplayStyle: carouselDisplayStyle !== null && carouselDisplayStyle !== void 0 ? carouselDisplayStyle : CarouselDisplayStyle.Default,
        };
    }, [backgroundColor, carouselDisplayStyle, isBackgroundDark, textColor]);
    const isAdjacentLayout = component.carouselDisplayStyle === CarouselDisplayStyle.Adjacent;
    const subComponents = component.content.map((childComponent, index) => {
        const subComponent = (React.createElement(GenericSubComponent, { component: childComponent, alias: component === null || component === void 0 ? void 0 : component.alias, moreLinkText: moreLinkText, zoneIds: zoneIds, key: `sub-component-${index.toString()}` }));
        if (isAdjacentLayout) {
            return (
            // Add a grid cell for the adjacent content.
            React.createElement(FlexGrid, { xs: 12, l: 6, key: `grid-cell-${index.toString()}` }, subComponent));
        }
        return subComponent;
    });
    return (React.createElement(GenericRootComponentContext.Provider, { value: contextValues },
        React.createElement(PersonalisedProductContextProvider, { alias: alias },
            React.createElement(Styler, { component: "section", "data-id": `section-${component === null || component === void 0 ? void 0 : component.alias}-generic-component`, bg: backgroundColor, pos: "relative", overflow: "hidden" // Required for Carousel overflow
             },
                isAdjacentLayout && (
                // This opaque panel is used to mask carousel overflow
                React.createElement(Styler, { pos: "absolute", top: "0", left: "0", w: "50%", h: "100%", zIndex: 1, display: { xs: 'none', l: 'block' }, bg: `linear-gradient(to ${isRTL ? 'right' : 'left'}, transparent, ${colorToCssValue(backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : 'background.body')} 120px)`, baseStyles: {
                        backdropFilter: 'blur(12px)',
                    } })),
                React.createElement(BackgroundImage, Object.assign({ component: "div" }, backgroundProps, { py: DEFAULT_COMPONENT_PADDING }),
                    React.createElement(Container, null, isAdjacentLayout ? (
                    // Add a grid container for the adjacent content.
                    React.createElement(FlexGrid, { container: true, "data-adjacent-layout-grid": true }, subComponents)) : (subComponents)))))));
}
